import { UserRoles } from '~entities/users/model/types';

/**
 * ENR-3529: shared Admin+ gate for billing deep-link routes.
 * Returns the redirect target when the caller lacks Admin access.
 */
export function getBillingAdminRedirect(input: {
  hasAdminAccess: boolean;
  studentId?: string;
}):
  | { redirectTo: '/dashboard' }
  | { redirectTo: '/students/$studentId/details'; studentId: string }
  | null {
  if (input.hasAdminAccess) {
    return null;
  }
  if (input.studentId) {
    return {
      redirectTo: '/students/$studentId/details',
      studentId: input.studentId,
    };
  }
  return { redirectTo: '/dashboard' };
}

export const BILLING_ADMIN_MIN_ROLE = UserRoles.ADMIN;
